<template>
  <div class="twoHundredAndEleven">
    <van-image class="backImg" :src="objImg.wtBackImg" />
    <!-- 搜索 -->
    <div class="top">
      <div class="v-serach">
        <van-image :src="objImg.wtsearchImg" />
        <div class="v-input-warpper">
          <input
            v-model="inputSearch"
            @input="onInputChang"
            placeholder="请输入关键字"
          />
          <van-icon
            class="clearImg"
            @click="clearClick"
            name="clear"
            size="20"
          />
        </div>
        <button class="v-button" @click="toSeachBtn">
          <span>搜索</span>
        </button>
      </div>
      <div class="statement" @click="popupStatement">声明</div>
    </div>

    <div class="poset">
      <van-image class="posetImg" :src="objImg.wtnavImg" />
    </div>

    <div class="fiyDiv">
      <!-- 导航栏 -->
      <nav>
        <div class="nav">
          <ul>
            <li
              v-for="(item, index) in navList"
              :key="item.id"
              :class="active === item.id ? 'isA' : ''"
              @click="fiyClickFn(item, index)"
            >
              {{ item.name }}
              <van-image
                class="isAImg"
                v-show="active === item.id"
                :src="objImg.wtisAImg"
              />
            </li>
          </ul>
        </div>
        <van-icon class="navWap" @click="toclassfiy" name="wap-nav" />
      </nav>
      <!-- 内容 -->
      <van-list
        v-model:loading="loading"
        :finished="finished"
        :finished-text="finishedText"
        ref="vanListRef"
        :offset="50"
      >
        <van-cell
          v-for="item in articleContentList"
          :key="item.id"
          @click="toothorpage(item.link)"
        >
          <div class="list">
            <div class="one">{{ item.title }}</div>
            <div class="two">
              <span>{{ item.mp_name }}</span>
              <span>{{ item.pub_time }}</span>
            </div>
          </div>
        </van-cell>
      </van-list>
    </div>

    <van-image @click="goBack" class="returnImg" :src="objImg.returnImg" />
  </div>
  <popup ref="popupRef" />
</template>
<script setup>
import wtBackImg from "../../assets/image/wtBack.png";
import wtsearchImg from "../../assets/image/WT-search.png";
import wtsearchbtnImg from "../../assets/image/WT-searchbtn.png";
import wtisAImg from "../../assets/image/WT-isAtop.png";
import wtnavImg from "../../assets/image/C-one1.png";
import returnImg from "../../assets/image/C-返回.png";
import wtfontBackImg from "../../assets/image/WT-fontBack.png";
import titleImg from "../../assets/image/C-title.png";
import titleFontImg from "../../assets/image/C-title-font.png";
import popup from "../../components/popupStatement.vue";
import { ref, onBeforeMount, onMounted, watch, nextTick } from "vue";
import { indexlist, getclassfiy, sharewx } from "../../api/index";
import { useRouter, useRoute, onBeforeRouteUpdate } from "vue-router";
import useDataInfo from "../../store/index";
import wx from "weixin-js-sdk";
const dataInfo = useDataInfo();
const props = defineProps(["title"]);
const route = useRoute();
const router = useRouter();
const objImg = ref({
  wtBackImg,
  wtsearchImg,
  wtsearchbtnImg,
  wtisAImg,
  wtnavImg,
  wtfontBackImg,
  returnImg,
  titleImg,
  titleFontImg,
});
const popupFlag = ref(true);
const emits = defineEmits(["ReturnFn"]);
const loading = ref(false);
const finished = ref(true);
const finishedText = ref();
const vanListRef = ref();
const active = ref(0); //id
const inputSearch = ref(); //输入框
const page = ref(1); //分页
const navList = ref([]); //导航栏数据
const articleContentList = ref([]); //导航内容list

const goBack = () => {
  emits("ReturnFn", "封面");
};
// 下拉到底部刷新
const onLoad = async () => {
  const topDom = document.querySelector(".twoHundredAndEleven");
  // console.log(topDom.scrollTop, topDom.offsetHeight, topDom.scrollHeight);
  // console.log(topDom.scrollTop + topDom.offsetHeight, "+");
  // var scrollTop = document.documentElement.scrollTop;
  // var windowHeight = window.innerHeight;
  // var documentHeight = Math.max(document.body.scrollHeight);
  var scrollTop = topDom.scrollTop;
  var windowHeight = topDom.offsetHeight;
  var documentHeight = Math.max(topDom.scrollHeight);
  if (scrollTop + windowHeight >= documentHeight) {
    switch (finishedText.value) {
      case "下滑刷新数据":
        page.value++;
        await listInfo(
          inputSearch.value,
          page.value,
          active.value,
          route.query.pid
        );
        loading.value = false;
        finished.value = true;
        break;
    }
  }
  // loading.value = false;
  // finished.value = true;
};
const toSeachBtn = async () => {
  page.value = 1;
  articleContentList.value = [];
  await listInfo(inputSearch.value, page.value, active.value, route.query.pid);
  loading.value = false;
};
// 跳转到其他小程序页面
const toothorpage = (url) => {
  //先缓存数据
  //list 需要判断是否从缓存取， 渲染完成后 定位到WXobjTop ，注意清缓存
  if (page.value >= 1) {
    // sessionStorage.setItem("WXPage", page.value);
    // sessionStorage.setItem("WXValue", value.value);
    // sessionStorage.setItem("WXlist", JSON.stringify(list.value));
  }
  window.open(url);
};
const toclassfiy = () => {
  router.push(`/classfiy?pid=${route.query.pid}&type=WT`);
};

const listInfo = async (val, page, active, pid) => {
  try {
    let res = await indexlist(val, page, active, pid);
    if (res.code === 1) {
      articleContentList.value.push(...res.data.data);
      if (res.data.data.length === 0) {
        finishedText.value = "暂无数据";
      } else {
        if (res.data.total > articleContentList.value.length) {
          finishedText.value = "下滑刷新数据";
        } else {
          finishedText.value = "没有更多数据了";
        }
      }
    }
  } catch (error) {
    console.log(error);
  }
};
const popupRef = ref();
const popupStatement = () => {
  popupRef.value.init(true, "popupTwo");
};
// 微信sdk的分享功能、
// 获取全路径
var url =
  "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
async function share() {
  const res = await sharewx(
    ["updateAppMessageShareData", "updateTimelineShareData"],
    url
  );
  if (res.code === 1) {
    wx.config({
      debug: false,
      appId: res.data.appid, // 和获取Ticke的必须一样------必填，公众号的唯一标识
      timestamp: res.data.timestamp, // 必填，生成签名的时间戳
      nonceStr: res.data.noncestr, // 必填，生成签名的随机串
      signature: res.data.signature, // 必填，签名，见附录1
      // 需要分享的列表项:发送给朋友，分享到朋友圈，分享到QQ，分享到QQ空间
      jsApiList: res.data.jsApiList,
    });
    // classfiy.value[active.value].name
    // 分享到朋友圈
    wx.ready(function () {
      wx.updateAppMessageShareData({
        title: props.title, // 分享标题
        desc: "科学引领 拥抱变革", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/title.png", // 分享图标
        success: function () {
          // 设置成功
        },
      });
      wx.updateTimelineShareData({
        title: props.title, // 分享标题·
        desc: "科学引领 拥抱变革", // 分享描述
        link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号 JS 安全域名一致
        imgUrl: "http://act.medsky.cn/title.png", // 分享图标
        success: function () {
          // 设置成功
        },
      });
    });
    wx.error(function (res) {});
  }
}
const fiyClickFn = async (row, index) => {
  sessionStorage.setItem("coverId", row.id);
  active.value = row.id;
  page.value = 1;
  articleContentList.value = [];
  await listInfo(inputSearch.value, page.value, active.value, route.query.pid);
  loading.value = false;
  url =
    "http://act.medsky.cn/#/?pid=" + route.query.pid + "&id=" + active.value;
  share();
};
onMounted(() => {
  document.documentElement.scrollTop = "0";
  const topDom = document.querySelector(".twoHundredAndEleven");
  topDom.addEventListener("scroll", onLoad);
  let flag = localStorage.getItem("popupTwo");
  if (flag) {
    switch (flag) {
      case "false":
        popupRef.value.init(false, "popupTwo");

        break;
      case "true":
        popupRef.value.init(true, "popupTwo");

        break;
    }
  } else {
    popupRef.value.init(true, "popupTwo");
    localStorage.setItem("popupTwo", true);
  }
});

const onInputChang = (e) => {
  let val = e.target.value;
  let dom = e.target.nextElementSibling;
  if (val) {
    dom.style.display = "block";
  } else {
    dom.style.display = "none";
  }
};
const clearClick = (e) => {
  e.target.style.display = "none";
  inputSearch.value = "";
};
watch(
  () => router.currentRoute.value.path,
  async (newVal, oldVal) => {
    switch (oldVal) {
      case "/classfiy":
        if (newVal === "/") {
          loading.value = true;
          finished.value = false;
          page.value = 1;
          articleContentList.value = [];
          active.value = Number(sessionStorage.getItem("coverId"));
          await listInfo(
            inputSearch.value,
            page.value,
            active.value,
            route.query.pid
          );
          loading.value = false;
          finished.value = true;
        }
        break;
    }
  },
  { immediate: true }
);
const init = (list) => {
  active.value = Number(sessionStorage.getItem("coverId"));
  navList.value = JSON.parse(JSON.stringify(list));
  navList.value.unshift({ id: 0, name: "全部" });
  listInfo(inputSearch.value, page.value, active.value, route.query.pid);
};

defineExpose({
  init,
});
</script>

<style lang="less" scoped>
.backImg {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0px;
  z-index: -1;
  img {
    width: 100%;
    height: 100%;
  }
}

.returnImg {
  width: 50px;
  height: 50px;
  position: fixed;
  right: 15px;
  bottom: 120px;
  z-index: 20;
  img {
    width: 100%;
    height: 100%;
  }
}
.twoHundredAndEleven {
  overflow: auto;
  .top {
    margin: 8px 15px 0 15px;
    display: flex;
    align-items: center;
    .statement {
      font-size: 14px;
      color: #1430e9;
      flex: 1;
      margin-left: 8px;
      cursor: pointer;
    }
  }

  // 搜索
  .v-serach {
    width: 309px;

    position: relative;
    .van-image {
      width: 103px;
      height: 34px;
      position: absolute;
      z-index: 2;
      bottom: 0;
      left: 0;
    }
    .v-input-warpper {
      //width:100%;
      //height:34px;
      border-radius: 5px;
      overflow: hidden;
      position: relative;
      z-index: 1;
      input {
        width: 100%;
        height: 34px;
        padding: 0;
        padding-left: 37px;
        font-size: 14px;
        border: none;
        border-radius: 5px;
        box-sizing: border-box;
        position: relative;
        z-index: 3;
      }
      input::placeholder {
        font-size: 14px;
        color: #bec6e3;
      }
      .clearImg {
        position: absolute;
        top: 10px;
        right: 60px;
        z-index: 10;
        background: rgba(255, 255, 255, 0.3);
        border-radius: 25px;
        color: #f1f1f1;
        cursor: pointer;
        display: none;
      }
    }
    .v-button::before {
      content: "";
      width: 50px;
      height: 24px;
      display: inline-block;
      border-radius: 5px;
      position: absolute;
      top: 0;
      left: 0;
      box-shadow: inset 2px 2px 1px 2px rgba(255, 255, 255, 0.1),
        inset -2px -2px 1px 2px rgba(255, 255, 255, 0.1);
    }
    .v-button {
      min-width: 50px;
      min-height: 24px;
      border: none;
      position: absolute;
      right: 8px;
      bottom: 5px;
      padding: 0;
      cursor: pointer;
      border-radius: 5px;
      background-image: linear-gradient(45deg, #ab90f5, #728fff);
      z-index: 4;

      span {
        font-size: 14px;
        white-space: nowrap;
        line-height: 14px;
        font-weight: 500;
        color: #ffffff;
        position: absolute;
        top: 0;
        left: 0;
        bottom: 0;
        right: 0;
        border-radius: 5px;
        padding: 5px 11px;
      }
    }
  }

  .poset {
    margin: 14px 15px 8px 15px;
    position: relative;
    .posetImg {
      width: 100%;
      height: 100%;
      img {
        width: 100%;
        height: 100%;
      }
    }
    .font {
      font-weight: bold;
      font-size: 13px;
      color: #000000;
      position: absolute;
      top: 0;
      right: 17px;
      span {
        position: relative;
        z-index: 1;
      }
      .van-image {
        width: 18px;
        height: 19px;
        position: absolute;
        top: -3px;
        right: -8px;
        z-index: 0;
        img {
          width: 100%;
          height: 100%;
        }
      }
    }
  }

  // 导航栏
  .fiyDiv {
    padding: 0 15px;
    nav {
      width: 100%;
      border-radius: 5px;
      display: flex;
      justify-content: space-between;
      border: 1px solid #d9e6ff;
      overflow: hidden;
      background: rgba(255, 255, 255, 0.6);
      .nav::-webkit-scrollbar {
        height: 2px;
      }
      .nav::-webkit-scrollbar-thumb {
        border-radius: 5px;
        background: #e1e7f8;
      }
      .nav {
        width: 306px;
        overflow: auto;
        ul {
          overflow: hidden;
          display: flex;
          float: left;
          li {
            white-space: nowrap;
            position: relative;
            padding: 12px;
            font-size: 14px;
          }
          li:not(li:last-child)::after {
            content: "";
            display: inline-block;
            width: 1px;
            height: 14px;
            position: absolute;
            right: 0;
            background: #e1e7f8;
          }
          .isAImg {
            position: absolute;
            left: 0;
            right: 0;
            bottom: 4px;
            text-align: center;
            width: 24px;
            height: 7px;
            margin: 0 auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .isA {
            color: #1c58dd;
            font-weight: bold;
            font-size: 14px;
          }
        }
      }

      .navWap {
        width: 39px;
        height: 42px;
        background: #fff;
        text-align: center;
        line-height: 38px;
        font-size: 25px;
        // position: absolute;
        // right: -2px;
        // top: 0;
        border-radius: 0 5px 5px 0;
      }
    }
    .van-list {
      margin-top: 8px;
      .van-cell {
        padding: 0;
        background: rgba(255, 255, 255, 0);
        .list {
          position: relative;
          min-height: 91px;
          padding: 14px 17px 14px 14px;
          margin-bottom: 10px;
          border-radius: 5px;
          background: rgba(255, 255, 255, 0.6);
          border: 1px solid #fff;
          box-sizing: border-box;
          .one {
            font-size: 14px;
            color: #372b2f;
            line-height: 23px;
            margin-bottom: 14px;
          }
          .two {
            font-size: 12px;
            span:nth-child(1) {
              color: #646c81;
              margin-right: 18px;
            }
            span:nth-child(2) {
              color: #b8b8b8;
            }
          }
          div {
            text-align: left;
          }
        }
      }
    }
  }
}
</style>
